export default {
  statuses: ['All', 'Active', 'Deleted'],
  status: 'Status',
  deleteConfirmationTitle: 'Delete admin',
  deleteConfirmationText: 'Do you really want to delete admin: {fullName}?',
  restoreConfirmationTitle: 'Restore admin',
  restoreConfirmationText: 'Do you want to restore admin: {fullName}?',
};
